export const CO_CONTENT = {
  hero: {
    kicker: 'Para construtoras e incorporadoras',
    title: 'Sua obra só mostra o custo real quando já é tarde para corrigir?',
    subtitle:
      'Controle canteiro, seções, permutas e pré-faturamento em um único sistema — com registro diário de trabalho e funil de negociação de unidades organizado.',
    cta: 'Quero controlar minhas obras',
    ctaMessage: 'Quero conhecer o sistema para construtora do 77Gestão',
    urgency: 'Enquanto o fechamento da obra depende de reunir planilha solta, o custo real só aparece quando o prejuízo já aconteceu.',
  },

  statsStrip: [
    { number: '100%', label: 'das obras com canteiro e seções organizados', icon: 'fa-solid fa-city' },
    { number: 'Diário', label: 'registro de trabalho executado na obra', icon: 'fa-regular fa-calendar-check' },
    { number: '1 lugar', label: 'para permutas e negociação de unidades', icon: 'fa-solid fa-right-left' },
  ],

  pain: {
    title: 'Se a gestão da sua obra é assim, o problema é falta de sistema, não de esforço',
    intro:
      'Construtoras e incorporadoras de pequeno e médio porte esbarram nos mesmos gargalos quando o controle da obra é feito em planilhas soltas.',
    items: [
      { icon: 'fa-solid fa-magnifying-glass-dollar', text: 'Obra sem controle real de custo até o fechamento — a surpresa só aparece no final.' },
      { icon: 'fa-solid fa-right-left', text: 'Permuta de terreno ou imóvel controlada de forma informal, sem vínculo claro com a obra.' },
      { icon: 'fa-solid fa-file-invoice-dollar', text: 'Pré-faturamento feito manualmente, reunindo informação solta de vários lugares.' },
      { icon: 'fa-solid fa-filter', text: 'Venda de unidade sem funil organizado — cada corretor negocia do seu jeito.' },
      { icon: 'fa-solid fa-clipboard-list', text: 'Registro diário de obra que depende de anotação de campo, difícil de consolidar depois.' },
    ],
  },

  midCta: {
    text: 'E se cada canteiro de obra tivesse controle de custo, permuta e funil de venda organizados desde o início?',
    cta: 'Quero ver como funciona',
    ctaMessage: 'Quero ver uma demonstração do sistema para construtora do 77Gestão',
  },

  solution: {
    title: 'Controle real de obra, do canteiro à negociação da unidade',
    intro:
      'O módulo de obras do 77Gestão foi pensado para construtoras e incorporadoras que precisam de controle de custo real e organização na venda.',
    cards: [
      {
        icon: 'fa-solid fa-city',
        title: 'Canteiro de obra estruturado',
        text: 'Cadastre o canteiro e organize suas seções — quadras e lotes — para saber exatamente onde cada custo e cada unidade estão.',
      },
      {
        icon: 'fa-regular fa-calendar-check',
        title: 'Registro diário de trabalho',
        text: 'Registre o que foi executado na obra dia a dia, criando a base real para o fechamento periódico.',
      },
      {
        icon: 'fa-solid fa-file-invoice-dollar',
        title: 'Fechamento periódico com pré-faturamento',
        text: 'Consolide os registros diários em um fechamento periódico que já gera o pré-faturamento, sem reunir planilha solta.',
      },
      {
        icon: 'fa-solid fa-right-left',
        title: 'Permutas vinculadas à obra',
        text: 'Controle as permutas de terreno ou imóvel vinculadas diretamente à obra correspondente, sem controle informal à parte.',
      },
      {
        icon: 'fa-solid fa-filter',
        title: 'Funil de negociação por fases',
        text: 'Organize a negociação de venda de cada unidade em fases claras, do primeiro contato ao fechamento.',
      },
      {
        icon: 'fa-solid fa-building-columns',
        title: 'Financeiro integrado',
        text: 'Contas a pagar e a receber, DRE e centro de custo conectados a cada obra e cada unidade.',
      },
    ],
  },

  proof: {
    title: 'O que muda quando a obra deixa de depender de planilha solta',
    intro:
      'Uma incorporadora que controlava canteiro, permuta e negociação de unidades em planilhas separadas só via o custo real da obra no fechamento.',
    stats: [
      { number: '100%', label: 'das obras com seções e lotes organizados no sistema' },
      { number: 'Periódico', label: 'fechamento com pré-faturamento consolidado' },
      { number: '1 funil', label: 'de negociação por fases para toda a equipe' },
    ],
    paragraphs: [
      'Depois da implantação acompanhada, cada canteiro passou a ter suas seções, registros diários de trabalho e permutas organizados dentro do próprio sistema.',
      'O fechamento periódico consolidou automaticamente as informações de campo, entregando o pré-faturamento sem precisar reunir planilha de vários setores.',
    ],
    highlight: 'Resultado: custo de obra visível antes do fechamento e negociação de unidades organizada por fases.',
    cta: 'Quero esse controle nas minhas obras',
    ctaMessage: 'Vi o resultado e quero entender como controlar minhas obras com o 77Gestão',
  },

  benefits: {
    title: 'Os três pilares para a gestão de obras',
    items: [
      {
        icon: 'fa-solid fa-city',
        title: 'Estrutura',
        text: 'Canteiro, seções, quadras e lotes organizados, com cada custo e cada unidade no lugar certo.',
      },
      {
        icon: 'fa-regular fa-calendar-check',
        title: 'Registro',
        text: 'Trabalho executado registrado dia a dia, virando base real para o fechamento periódico.',
      },
      {
        icon: 'fa-solid fa-filter',
        title: 'Negociação',
        text: 'Funil de venda por fases e permutas vinculadas à obra, sem controle informal à parte.',
      },
    ],
  },

  differentials: {
    title: 'Por que construtoras escolhem o 77Gestão',
    items: [
      { icon: 'fa-solid fa-puzzle-piece', text: 'Módulo de obras completo, do canteiro à negociação da unidade, adaptável ao porte da construtora.' },
      { icon: 'fa-solid fa-handshake', text: 'Implantação acompanhada: alguém ajuda a estruturar canteiro, seções e fluxo de fechamento com você.' },
      { icon: 'fa-solid fa-headset', text: 'Suporte humano, próximo e bem avaliado.' },
      { icon: 'fa-solid fa-link', text: 'Obras, financeiro e negociação de unidades integrados em um único sistema.' },
    ],
  },

  faq: {
    title: 'Perguntas comuns antes de começar',
    items: [
      {
        question: 'O sistema serve para incorporadora de pequeno e médio porte?',
        answer:
          'Sim. O módulo de obras foi pensado para construtoras e incorporadoras de pequeno e médio porte que precisam de controle real de custo sem uma estrutura pesada de ERP.',
      },
      {
        question: 'Como funciona o fechamento periódico da obra?',
        answer:
          'Os registros diários de trabalho executado na obra são consolidados em um fechamento periódico, que já gera o pré-faturamento com base no que foi realmente registrado em campo.',
      },
      {
        question: 'Dá para controlar permuta de terreno junto com a obra?',
        answer:
          'Sim. As permutas ficam vinculadas diretamente à obra correspondente, em vez de serem controladas à parte de forma informal.',
      },
      {
        question: 'Como funciona o funil de negociação de unidades?',
        answer:
          'Cada unidade em negociação passa por fases organizadas dentro do sistema, dando visibilidade de onde cada negociação está, sem depender do controle individual de cada corretor.',
      },
      {
        question: 'Preciso reestruturar como organizo meus canteiros?',
        answer:
          'Não. Na implantação acompanhada, o canteiro e suas seções — quadras e lotes — são configurados de acordo com a estrutura real da sua obra.',
      },
    ],
  },

  ctaFinal: {
    title: 'Pare de descobrir o custo real da obra só no fechamento',
    subtitle:
      'Agende sua demonstração e veja, na prática, como controlar canteiro, permutas, fechamento periódico e negociação de unidades em um único sistema.',
    cta: 'Agendar demonstração agora',
    ctaMessage: 'Quero agendar uma demonstração do sistema para construtora do 77Gestão',
  },

  seo: {
    title: 'Sistema para Construtora — Gestão de Obras e Pré-faturamento | 77Gestão',
    description:
      'Sistema de gestão de obras para construtoras e incorporadoras: canteiro com seções e lotes, registro diário de trabalho, fechamento periódico com pré-faturamento, permutas e funil de negociação de unidades. Agende uma demonstração.',
  },
};
